import React from 'react'
import AuthContext from '../contexts/amplify-context'

const useAuth = () => React.useContext(AuthContext);

export default useAuth
